const links = {
  zj: 'https://www.zijing365.cn/',
  zijingPC: 'https://jigou.zijing365.cn/',
  headmaster: 'https://pc.1d1d100.com/login',
  onlineChat: 'https://intelcc-user.icsoc.net?channelKey=8710ef4410817d56e0e314075be124b2&init=1'
};
export default links;
